import React from "react";
import { Dialog, DialogContent, Button, CircularProgress } from "@mui/material";
import { CloseOutlined } from "@ant-design/icons";
import "../css/LogoutConfirmationDialog.css";

const LogoutConfirmationDialog = ({ open, onClose, onSave, isLoading = false }) => {
  return (
    <Dialog
      open={open ?? false}
      onClose={onClose}
      PaperProps={{
        className: "logout-dialog-container",
        sx: { borderRadius: "20px" },
      }}
    >
      <DialogContent>
        <CloseOutlined className="logout-dialog-close" onClick={onClose} />
        <div className="logout-dialog-content">
          <div className="logout-dialog-title-container">
            <div className="logout-dialog-title">Do you want to logout?</div>
          </div>
          <Button variant="contained" color="send" onClick={onSave}>
            {isLoading ? <CircularProgress size={20} color="inherit" /> : "Yes"}
          </Button>
          <Button
            variant="contained"
            onClick={onClose}
            color="secondaryButton"
          >
            No
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default LogoutConfirmationDialog;
